<template>
    <ElevatedCard :widthType="'third'">
        <HeaderWidget
            :iconUrl="loadIcon"
            :title="widget.libelle"
            :mode-edition='true'
            @filtre='filtre'
            @dupliquer='dupliquer'
            @suppression='suppression' />
        <div>
            <span v-if='widget.sites == null || widget.sites.length > 1' class='site-widget'>{{$t('multisites')}}</span>
            <span v-else v-for='site in widget.sites' :key='site.id' class='site-widget'>
                {{site.description}}
                <span v-if='site.id !== widget.sites[widget.sites.length - 1].id'>, </span>
            </span>
        </div>
        <div class="card-content">
            <div class="tiles-container">
                <Tile
                    class="tile"
                    :value="2"
                    :titleNotBold="$tc('widgetBilling.facture', 2)"
                    :titleInBold="$t('widgetBilling.retard')"
                    :titleEnd="$t('widgetBilling.paiement')"
                    :color="'--edition-clair'"
                    :fontSize="'19px'"
                    :is-loading='false'
                />
                <Tile
                    class="tile"
                    :value="1"
                    :titleNotBold="$tc('widgetBilling.facture', 1)"
                    :titleInBold="$t('widgetBilling.attente')"
                    :titleEnd="$t('widgetBilling.paiement')"
                    :color="'--edition-medium'"
                    :fontSize="'19px'"
                    :is-loading='false'
                />
                <Tile
                class="tile"
                :value="5"
                :titleNotBold="$tc('widgetBilling.facture', 5)"
                :titleInBold="$t('widgetBilling.payees')"
                :color="'--edition-fonce'"
                :fontSize="'19px'"
                :is-loading='false'
                />
            </div>
            <div>
                <div class="text">
                    {{ $t('widgetBilling.jourEnRetard') }}  <span class="text accent">{{ $tc('widgetBilling.nbJourEnRetard', 2) }}</span>
                </div>
            </div>
        </div>
    </ElevatedCard>
</template>

<script lang='ts'>
import { defineComponent, PropType } from 'vue';
import ElevatedCard from '../../../components/ui-components/ElevatedCard.vue';
import HeaderWidget from '../../../components/ui-components/HeaderWidget.vue';
import Tile from '../../../components/ui-components/Tile.vue';
import { Widget } from '@/models/Widget';

export default defineComponent({
    name: 'EditionBilling',
    components: { HeaderWidget, Tile, ElevatedCard },
    props: {
        widget:{ type: Object as PropType<Widget>, required: true },
    },
    computed: {
        loadIcon() {
            return require('@/assets/img/menu/receipt_long_45.png');
        },
    },
    methods: {
        filtre() {
            this.$emit('filtre');
        },
        dupliquer() {
            this.$emit('dupliquer');
        },
        suppression() {
            this.$emit('suppression');
        },
    },
});
</script>

<style scoped>
.tiles-container {
    display: flex;
    justify-content: space-around;
    margin-bottom: 7px;
    width: 90%;
    min-height: 30%;
    gap: 25px;
}
@media screen and (max-width: 1600px) {
    .tiles-container {
        width: 100%;
        gap: 10px
    }
}
.tile {
    cursor: pointer;
    height: 120px;
    max-height: 20vh;
}
.text {
    text-align: center;
    font-size: var(--font-size-high-medium);
    font-variant-numeric: lining-nums;
}
.card-content {
    background-color: var(--white);
    padding: 10px;
    font-size: var(--font-size-high-medium);
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    justify-content: center;
}
.accent {
    color: var(--red);
}
</style>
